
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import BottomNav from './components/BottomNav';
import BalanceCard from './components/BalanceCard';
import QuickActions from './components/QuickActions';
import RecentTransfers from './components/RecentTransfers';
import ExchangeRates from './components/ExchangeRates';

export default function Dashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (!isLoggedIn) {
      navigate('/login');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50" dir="rtl">
      <Navbar />
      
      <div className="pt-20 pb-20 px-4">
        {/* بطاقة الرصيد */}
        <BalanceCard />
        
        {/* الإجراءات السريعة */}
        <QuickActions />
        
        {/* أسعار الصرف */}
        <ExchangeRates />
        
        {/* التحويلات الأخيرة */}
        <RecentTransfers />
      </div>

      <BottomNav />
    </div>
  );
}
